import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { useNavigate } from "react-router-dom";
import { TableSearchInput } from "components/common/input";
import { AddBtn } from "components/common/button";
import { FaqListTable } from "components/faq";
import { PrimayPagination } from "components/common/pagination";
import type { IFaqList } from "service/interface/help";
import routerConstant from "service/constant/routerConstant";

export function FaqListPage() {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectPage, setSelectPage] = useState<number>(1);
  const [listData, setListData] = useState<{ count: number; data: IFaqList[] }>(
    { count: 0, data: [] },
  );

  const { data } = useSWR(
    `/admin/manage/faq?limit=12&offset=${
      selectPage * 12 - 12
    }&search=${searchValue}`,
  );

  useEffect(() => {
    if (data) {
      setListData(data);
    }
  }, [data]);

  const handleAddBtn = () => {
    navigate(`${routerConstant.FAQ.index}/add`);
  };

  return (
    <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
      <div className="mx-auto w-[1167px] p-[78px_80px_55px_64px]">
        <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
          메모리올 관리자 화면
        </p>
        <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
          자주 묻는 질문 관리
        </p>
        <div className="mb-[24px] mt-[16px] flex items-center justify-between">
          <TableSearchInput
            value={searchValue}
            setValue={setSearchValue}
            placeholder="키워드를 검색하세요"
          />
          <AddBtn onClick={handleAddBtn} />
        </div>
        <FaqListTable data={listData.data} />
        <div className="mt-[32px] flex justify-end">
          <PrimayPagination
            listLength={Math.ceil(listData.count / 12)}
            pageNumber={selectPage}
            setPageNumber={setSelectPage}
          />
        </div>
      </div>
    </div>
  );
}
